import type { HttpDelete } from '@/shared/infra/http'
import type { DeleteAnnouncement } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

export class EdgeDeleteAnnouncementRepository {
  constructor(private readonly http: HttpDelete) {}

  execute: DeleteAnnouncement = async (params) => {
    const query = `?orgId=${encodeURIComponent(params.orgId)}&orgType=${params.orgType}`
    try {
      await this.http.delete<unknown>({
        url: `/connect/announcements/${encodeURIComponent(params.announcementId)}${query}`,
      })
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
